import React from 'react';
import ActionItemsIcon from 'assets/svg/ActionItemsIcon';

const isHelpEnabled = (): boolean => {
    const workspace = process.env.REACT_APP_VITE_PRODUCT_FRUIT_WORKSPACE;
    return Boolean(workspace && workspace !== 'null' && localStorage.getItem('email'));
};

const ProductFruitHelpLauncher = () => {
    const openHelpCenter = () => {
        const inAppCenter = (window as any).productFruits?.api?.inAppCenter;
        if (!inAppCenter) {
            return;
        }

        if (inAppCenter.isOpened?.()) {
            inAppCenter.close();
        } else {
            inAppCenter.open();
        }
    };

    if (!isHelpEnabled()) {
        return null;
    }

    return (
        <button
            type="button"
            aria-label="Help Center"
            onClick={openHelpCenter}
            className="flex shrink-0 cursor-pointer items-center border-0 bg-transparent p-0"
            style={{ width: 24, height: 24, minWidth: 24, minHeight: 24 }}
        >
            <ActionItemsIcon width={24} height={24} />
        </button>
    );
};

export default ProductFruitHelpLauncher;
